import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { TransactionRequirementService } from 'src/app/pages/transaction/services/transaction-requirement.service';
import { NgxExtendedPdfViewerService } from 'ngx-extended-pdf-viewer';
import { TransactionService } from 'src/app/pages/transaction-admin/services/transaction.service';
import { TransactionExternalService } from 'src/app/pages/transaction/services/transaction-external.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseManagement } from 'src/app/core/services/base-management';
import { DialogYesNoComponent } from 'src/app/core/components/dialog-yes-no/dialog-yes-no.component';
import { Router, ActivatedRoute } from '@angular/router';
import { TransactionRequirementItemServiceService } from 'src/app/pages/transaction/services/transaction-requirement-item.service';
import { TransactionRevisionExternalService } from 'src/app/pages/transaction/services/transaction-revision-status-external.service';
import { DialogOkComponent } from '../dialog-ok/dialog-ok.component';
export class PdfViewerComponent extends BaseManagement {
    constructor(route, router, mainService, ngxService, transactionService, transactionExternalService, translate, transactionRequirementItemServiceService, transactionRevisionExternalService) {
        super();
        this.route = route;
        this.router = router;
        this.mainService = mainService;
        this.ngxService = ngxService;
        this.transactionService = transactionService;
        this.transactionExternalService = transactionExternalService;
        this.translate = translate;
        this.transactionRequirementItemServiceService = transactionRequirementItemServiceService;
        this.transactionRevisionExternalService = transactionRevisionExternalService;
        this.validateForm = false;
        this.serverError = '';
        this.itemToEdit = { Id: null };
        this.minimize = false;
        this.subscriptions = [];
        this.revisionStatusLog = {};
        this.isFormValid = false;
        this.formData = null;
        this.mainService.pdfCommunicator.subscribe((data) => {
            if (data == "save-data") {
                this.tryDownloadAsBlob("submit-for-review");
            }
        });
    }
    ngOnInit() {
        this.requirementItem = this.transactionRequirementItemServiceService.requirementItem;
        console.log(this.requirementItem);
        this.pdfSrc = this.mainService.fileToLoad;
        let params = {};
        params.userProcessId = this.requirementItem.ProcessId;
        params.requirementId = this.requirementItem.RequirementId;
        this.transactionRevisionExternalService.getRevisionStatusLog(params)
            .then((data) => {
            this.revisionStatusLog = {
                CompletedDate: "n/a",
                RemediedDate: "n/a"
            };
            if (data) {
                this.revisionStatusLog = data;
            }
            console.log(this.revisionStatusLog);
            this.validateRequiredFields();
        })
            .catch((err) => {
            console.log('error', err);
            this.serverError = "An error ocurred when getting the revision status log.";
        });
    }
    validateRequiredFields() {
        let formData = this.mainService.formData;
        // Objeto para almacenar las propiedades que contengan 'required' en su nombre
        let requiredFieldsObject = {};
        let requiredFieldsCount = 0;
        // Verificar que formData existe y es un objeto
        if (formData && typeof formData === 'object') {
            // Iterar sobre todas las propiedades del objeto formData
            for (let propertyName in formData) {
                // Verificar si la propiedad contiene la palabra 'required' en su nombre
                if (propertyName.toLowerCase().includes('required')) {
                    requiredFieldsObject[propertyName] = formData[propertyName];
                    requiredFieldsCount++;
                }
            }
        }
        // Verificar si todas las propiedades required tienen valor
        for (let propertyName in requiredFieldsObject) {
            let value = requiredFieldsObject[propertyName];
            // Verificar si el valor es string vacío, null, undefined
            if (value === '' || value === null || value === undefined) {
                this.isFormValid = false;
                return false; // Al menos una no tiene valor
            }
        }
        // Si llegamos aquí, todas tienen valor
        this.isFormValid = true;
        return true;
    }
    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
    trySubmitForReview(action) {
        if (this.isSaving())
            return;
        this.mainService.pdfCommunicator
            .next("save-data");
    }
    minimizeRevisionAlert(action) {
        this.minimize = false;
        if (action == true) {
            this.minimize = true;
        }
    }
    close() {
        this.translate
            .get([
            'message.deleteConfirmText',
            'message.yes',
            'message.no',
            'message.requirement',
            'message.deleted',
            'message.unableRequirement',
            'message.done',
            'pdfform.closeWarn',
        ])
            .subscribe((translations) => {
            const dialogRef = this.dialog.open(DialogYesNoComponent, {
                width: '250px',
                data: {
                    msg: translations['pdfform.closeWarn'],
                    yesText: translations['message.yes'],
                    noText: translations['message.no'],
                },
            });
            dialogRef.afterClosed().subscribe((result) => {
                if (result === 1) {
                    this.mainService.fileToLoad = null;
                }
            });
        });
    }
    tryDownloadAsBlob(action) {
        if (!this.isFormValid) {
            this.alertCompleteForm();
            return;
        }
        if (this.isSaving())
            return;
        this.translate
            .get([
            'message.deleteConfirmText',
            'message.yes',
            'message.no',
            'message.requirement',
            'message.deleted',
            'message.unableRequirement',
            'message.done',
            'pdfform.saveWarn',
        ])
            .subscribe((translations) => {
            const dialogRef = this.dialog.open(DialogYesNoComponent, {
                width: '250px',
                data: {
                    msg: translations['pdfform.saveWarn'],
                    yesText: translations['message.yes'],
                    noText: translations['message.no'],
                },
            });
            dialogRef.afterClosed().subscribe((result) => {
                if (result === 1) {
                    this.startSaving(action);
                    this.downloadAsBlob(action);
                }
            });
        });
    }
    downloadAsBlob(action) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const blob = yield this.ngxService.getCurrentDocumentAsBlob();
            if (blob) {
                this.downloaded = 'The BLOB contains ' + blob.size + ' byte.';
                var formData = new FormData();
                var files = [];
                var filePdf = new File([blob], "name.pdf");
                files.push(filePdf);
                Array.from(files).forEach((f) => formData.append('file', f));
                formData.append('id', this.mainService.UserProcessRequirementId);
                formData.append('processId', this.mainService.ProcessId);
                formData.append('pdfFormJson', JSON.stringify(this.mainService.formData));
                formData.append('fileName', this.mainService.FileName);
                this.mainService
                    .uploadRequirementFile(formData)
                    .then((updatedRequirement) => {
                    this.mainService.pdfCommunicator.next("stop-saving");
                    this.requirement = updatedRequirement;
                    this.mainService.updateItemByField(this.requirement.UserProcessRequirementId, 'UserProcessRequirementId', this.requirement);
                    this.transactionService
                        .getTimeline(this.requirement.ProcessId)
                        .then(() => {
                        this.mainService.fileToLoad = null;
                        /*   this.transactionService.getTransactionsForUser()
                          .then(()=>{
        
                            
                          }); */
                    });
                })
                    .catch((err) => {
                    console.log('error', err);
                    this.translate
                        .get(['error.documentUplaod'])
                        .subscribe((translations) => {
                        this.stopSaving();
                        this.serverError = "Hubo un problema al intentar enviar el documento";
                    });
                });
            }
            else {
                this.downloaded = 'download failed';
                this.stopSaving();
            }
        });
    }
    onFormChange(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.validateForm) {
                this.validateRequiredFields();
            }
            else {
                this.isFormValid = true;
            }
        });
    }
    alertCompleteForm() {
        const dialogRef = this.dialog.open(DialogOkComponent, {
            data: {
                msg: 'Rellene todos los campos obligatorios.',
            }
        });
        dialogRef.afterClosed().subscribe((res) => { });
    }
}
